import { authPut } from './authMiddleware';

export const putCompanyPortfolio = (portfolioId) => {
    return authPut('/api/portfolio', portfolioId)
}